<template>
<div v-if="isShow" class="invoice bg_white">
  <Loading v-show="loading" />
  <div class="invoice_wrap mt24 pl16 pr16">
    <GetInvoiceNumber
      v-if="!isRegister"
      :invoiceNumber="invoiceNumber"
      @editInvoiceNumber="editInvoiceNumber"
    />
    <UpdateInvoiceNumber
      v-if="isRegister"
      :invoiceNumber="invoiceNumber"
      @updateInvoiceNumber="updateInvoiceNumber"
      @update:inputInvoiceNumber="handleInvoiceNumberUpdate"
    />
    <div class="error ab mt24">{{ errorDescription }}</div>
  </div>
</div>
<div v-else class="bg_white pt16 pb16 pl16 pr16 ab">アクセスエラー<br>coNPusアプリから再度開き直してください。</div>
</template>

<script>
import Check from '@/model/getToken';
import Invoice from '@/components/api/invoice/invoice';
import Loading from '@/components/common/Loading';
import SectionTitle from '@/components/common/SectionTitle';
import GetInvoiceNumber from '@/components/member/invoice/GetInvoiceNumber';
import UpdateInvoiceNumber from '@/components/member/invoice/UpdateInvoiceNumber';

export default {
  components: {
    Loading,
    GetInvoiceNumber,
    UpdateInvoiceNumber
  },
  data() {
    return {
      isShow: true,
      loading: false,
      invoiceNumber: '',
      isRegister: false, // インボイス入力時はtrue
      errorDescription: '',
    }
  },
  methods: {
    editInvoiceNumber() {
      this.isRegister = true;
    },
    handleInvoiceNumberUpdate(newInvoiceNumber) {
      this.invoiceNumber = newInvoiceNumber;
    },
    updateInvoiceNumber() {
      this.apiUpdateInvoiceNumber(this.invoiceNumber);
    },
    async apiGetInvoiceNumber() {
      await Invoice.getInvoiceNumber().then((val) => {
        console.log(val.invoiceNumber);
        this.invoiceNumber = val.invoiceNumber.replace('T', '');
      });
    },
    async apiUpdateInvoiceNumber(invoiceNumber) {
      this.loading = true;
      this.errorDescription = '';
      await Invoice.updateInvoiceNumber("T"+invoiceNumber).then((val) => {
        console.log(val);
        this.errorDescription = val.errorDescription;
        this.loading = false;
        if(val.resultStatus == 'OK') {
          this.initialized();
          this.isRegister = false;
          this.apiGetInvoiceNumber();
        }
      });
    },
    initialized() {
      this.loading = false;
      this.invoiceNumber = '';
      this.isRegister = false;
      this.errorDescription = '';
    },
  },
  async created() {
    let res;
    await Check.checkRequest(this.$route.query.code).then((val) => { res = val; });
    if(res) {
      this.initialized();
      this.apiGetInvoiceNumber();
    } else {
      this.isShow = false;
    }
  }
}
</script>

<style lang="css" scoped>
.color_red, .error {
  color: #FF3A3A;
}
</style>



// WEBPACK FOOTER //
// src/views/member/invoice/InvoiceNumber.vue